import React, { FC } from 'react';

import { useTranslation } from '@modernloop/i18n';

import useHasOrgAdminUser from 'src/hooks/useHasOrgAdminUser';

import AppWideBanner from './AppWideBanner';

const MissingOrgAdminUserBanner: FC = () => {
  const { t } = useTranslation();
  const { loading, hasAdmin } = useHasOrgAdminUser();
  if (loading) {
    // No need to show the banner while loading
    return null;
  }

  if (hasAdmin) {
    // No need to show the banner if the org has an admin
    return null;
  }

  return (
    <AppWideBanner
      backgroundColor="warning"
      color="max-contrast-grey"
      text={t('hiring-dashboard-nav:nav.banner.missingOrgAdmin')}
    />
  );
};

export default MissingOrgAdminUserBanner;
